import { Routes } from '@angular/router';
import { GameComponent } from '@core/game/game.component';
import { ActivateDeviceComponent } from '@features/auth/activate-device/activate-device.component';
import {
  activatedGuard,
  activatedHomeDeivceGuard,
  activatedSchoolDeviceGuard,
  loggedInGuard,
  notActivatedGuard,
  notLoggedInGuard,
} from '@features/auth/activated.guard';
import { DeviceNotActivatedComponent } from '@features/auth/device-not-activated/device-not-activated.component';
import { PlayerGroupSelectComponent } from '@features/auth/player-group-select/player-group-select.component';
import { ProfileSelectorComponent } from '@features/auth/profile-selector/profile-selector.component';
import { SchemaComponent } from '@features/dev/schema/schema.component';
import { ComponentTestPageComponent } from '@features/test-pages/component-test-page/component-test-page.component';
import { InventoryComponent } from '@features/test-pages/inventory/inventory.component';
import { SpriteSheetComponent } from '@features/test-pages/sprite-sheet/sprite-sheet.component';
import { SpritesComponent } from '@features/test-pages/sprites/sprites.component';
import { StoryActivityTestPageComponent } from '@features/test-pages/story-activity-test-page/story-activity-test-page.component';
import { TestPageCasinoComponent } from '@features/test-pages/test-page-casino/test-page-casino.component';
import { PortalHomeProfilesComponent } from './portal-home-profiles/portal-home-profiles.component';
import { PortalLoginComponent } from './portal-login/portal-login.component';
import { PortalSelectDeviceTypeComponent } from './portal-select-device-type/portal-select-device-type.component';

export const routes: Routes = [
  { path: '', component: GameComponent, canActivate: [activatedGuard, loggedInGuard] },
  { path: 'selectDeviceType', component: PortalSelectDeviceTypeComponent, canActivate: [notActivatedGuard] },
  { path: 'loginToHomeDevice', component: PortalLoginComponent, canActivate: [notActivatedGuard, notLoggedInGuard] },
  { path: 'activate', component: ActivateDeviceComponent, canActivate: [notActivatedGuard] },
  { path: 'not-activated', component: DeviceNotActivatedComponent, canActivate: [notActivatedGuard] },
  { path: 'select-profile', component: ProfileSelectorComponent, canActivate: [activatedGuard, activatedSchoolDeviceGuard] },
  { path: 'select-player-group', component: PlayerGroupSelectComponent, canActivate: [activatedSchoolDeviceGuard] },
  { path: 'select-home-profile', component: PortalHomeProfilesComponent, canActivate: [activatedHomeDeivceGuard, notLoggedInGuard] },
  // Test routes
  { path: 'story-activity-test', component: StoryActivityTestPageComponent, canActivate: [] },
  { path: 'component-test', component: ComponentTestPageComponent },
  { path: 'dev/schema', component: SchemaComponent, canActivate: [] },
  { path: 'test/sprites', component: SpritesComponent, canActivate: [] },
  { path: 'test/inventory', component: InventoryComponent, canActivate: [] },
  { path: 'test/sprite-sheet', component: SpriteSheetComponent, canActivate: [] },
  { path: 'test/casino', component: TestPageCasinoComponent, canActivate: [] },

  { path: ':params', component: GameComponent, canActivate: [activatedGuard] },
];
